















































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

import { CompanyModel, FileDownloadModel } from '@/core/models';
import { ConfirmDialogCpt, DialogCpt } from '@/core/components';
import { WorkshopService, QuestionnaireService } from '@/core/services';
import { ClientSkillsConsultantUpdateCpt } from './';

import AppVue from '@/AppVue.vue';
import EditClientFormCpt from './EditClientFormCpt.vue';

@Component({
  components: {
    ConfirmDialogCpt,
    EditClientFormCpt,
    ClientSkillsConsultantUpdateCpt,
    DialogCpt,
  },
})
export default class ClientDetailHeaderCpt extends AppVue {
  @Prop() model: CompanyModel;
  @Prop({ default: true }) isDelete: boolean;
  @Prop({ default: true }) isEdit: boolean;
  @Prop({ default: false }) loading: boolean;
  showDeleteDialog = false;
  showEditDialog = false;
  internalLoading = false;

  private async downloadPlanOnAPage() {
    this.internalLoading = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReportForCompany(
        this.model.id,
      );
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.internalLoading = false;
    }
  }

  private editCompanySuccess() {
    this.showEditDialog = false;
    this.$emit('company-updated');
  }

  private closeEditDialog() {
    this.showEditDialog = false;
  }

  private deleteCompany() {
    this.showDeleteDialog = true;
  }

  private editCompany() {
    this.showEditDialog = true;
  }

  private skillsConsultantUpdated() {
    this.$emit('company-updated');
  }

  private async closeConfirm(result: boolean) {
    this.showDeleteDialog = false;
    if (this.model.workshopId == null) {
      this.notify('Error', 'The client has no workshop assigned.', 'error');
      return;
    }
    this.internalLoading = true;
    try {
      if (result === true) {
        await WorkshopService.deleteWorkshopClient(this.model.workshopId, this.model.id);
        this.notify('Success', 'Client successfully deleted', 'success');
        this.$router.push('/admin/workshops');
      }
    } catch (err) {
      this.notify('Error', 'Something went wrong while deleting workshop', 'error');
    } finally {
      this.internalLoading = false;
    }
  }
}
